(function() {
var OmsImageUploader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

OmsImageUploader = (function() {
  function OmsImageUploader() {
    this.initialize_uploader = bind(this.initialize_uploader, this);
    this.setup_listeners = bind(this.setup_listeners, this);
    this.setup_listeners();
    this.initialize_uploader();
  }

  OmsImageUploader.prototype.setup_listeners = function() {
    $(document).off("click", ".image_uploader .change_image");
    $(document).off("click", ".image_uploader .cancel_change_image");
    $(document).off("click", ".image_uploader .clear_image");
    $(document).on("click", ".image_uploader .change_image", function(e) {
      var btn, field_name, field_wrapper;
      e.preventDefault();
      btn = $(e.target);
      field_wrapper = $(btn.parents(".image_uploader"));
      field_name = field_wrapper.data("image-field");
      field_wrapper.find(".change_image_field").slideDown();
      return field_wrapper.find(".image_control_btns").hide();
    });
    $(document).on("click", ".image_uploader .cancel_change_image", function(e) {
      var btn, field_name, field_wrapper;
      e.preventDefault();
      btn = $(e.target);
      field_wrapper = $(btn.parents(".image_uploader"));
      field_name = field_wrapper.data("image-field");
      field_wrapper.find(".change_image_field").slideUp();
      return field_wrapper.find(".image_control_btns").show();
    });
    return $(document).on("click", ".image_uploader .clear_image", function(e) {
      var $input_field, btn, field_model, field_name, field_wrapper, form, img_tag, placeholder_img;
      e.preventDefault();
      btn = $(e.target);
      field_wrapper = $(btn.parents(".image_uploader"));
      form = $(field_wrapper.parents('form:first'));
      field_model = field_wrapper.data("image-model");
      field_name = field_wrapper.data("image-field");
      placeholder_img = field_wrapper.data("image-placeholder");
      $input_field = field_wrapper.find("input[type='hidden'][data-s3-post-url]").first();
      $input_field.attr("value", "");
      $input_field.trigger("change");
      img_tag = field_wrapper.find("img");
      img_tag.attr("src", placeholder_img);
      return img_tag.attr("alt", "");
    });
  };

  OmsImageUploader.prototype.initialize_uploader = function(container) {
    if (container == null) {
      container = $('.form_with_image_upload.directUpload');
    }
    return container.find("input:file").each(function(i, elem) {
      var $input_field, bar_container, field_model, field_name, field_wrapper, file_input, form, max_height, max_width, progress_bar, s3_post_fields, s3_post_host, s3_post_url, submit_btn;
      file_input = $(elem);
      if (file_input.data("image-uploader-initialized")) {
        return;
      }
      file_input.data("image-uploader-initialized", true);
      form = $(file_input.parents('form:first'));
      field_wrapper = $(file_input.parents('.image_uploader'));
      field_model = field_wrapper.data("image-model");
      field_name = field_wrapper.data("image-field");
      $input_field = field_wrapper.find("input[type='hidden'][data-s3-post-url]").first();
      s3_post_url = $input_field.data("s3-post-url");
      s3_post_host = $input_field.data("s3-post-host");
      s3_post_fields = $input_field.data("s3-post-fields");
      max_width = +field_wrapper.data("max-width");
      max_height = +field_wrapper.data("max-height");
      submit_btn = form.find('button[type="submit"]');
      progress_bar = $("<div class='bar'></div>");
      bar_container = $("<div class='progress'></div>").append(progress_bar);
      this.content_type = "";
      file_input.after(bar_container);
      return file_input.fileupload({
        fileInput: file_input,
        url: s3_post_url,
        type: 'POST',
        autoUpload: true,
        paramName: 'file',
        dataType: 'XML',
        replaceFileInput: true,
        disableImageResize: false,
        disableValidation: false,
        imageMaxWidth: max_width,
        imageMaxHeight: max_height,
        acceptFileTypes: /(\.|\/)(gif|jpe?g|png|svg|webp)$/i,
        submit: (function(_this) {
          return function(e, data) {
            data.files[0].uploadName = data.files[0].name.replace(/[^A-Za-z0-9\-!_.'()]/g, '_');
            s3_post_fields["Content-Type"] = data.files[0].type;
            return data.formData = s3_post_fields;
          };
        })(this),
        progressall: function(e, data) {
          var progress;
          progress = parseInt(data.loaded / data.total * 100, 10);
          return progress_bar.css('width', progress + '%');
        },
        start: function(e, data) {
          submit_btn.prop('disabled', true);
          return progress_bar.css('background', 'green').css('display', 'block').css('width', '0%').text("Loading...");
        },
        done: function(e, data) {
          var key, url;
          submit_btn.prop('disabled', false);
          progress_bar.text("Uploading done");
          key = $(data.result).find("Key").text();
          url = "//" + s3_post_host + "/" + key;
          $input_field.attr("value", url);
          $input_field.trigger("change");
          field_wrapper.find("img").attr("src", url);
          field_wrapper.find(".show_image_field").show();
          field_wrapper.find(".change_image_field").slideUp();
          field_wrapper.find(".image_control_btns").fadeIn();
          return field_wrapper.find(".remove_if_image_changed").fadeOut();
        },
        fail: function(e, data) {
          submit_btn.prop('disabled', false);
          return progress_bar.css("background", "red").text("Failed");
        },
        processfail: function(e, data) {
          submit_btn.prop('disabled', false);
          return progress_bar.css("background", "red").css('display', 'block').text(data.files[data.index].error);
        }
      });
    });
  };

  return OmsImageUploader;

})();

window.alpha_oms.oms_image_uploader_constructor = OmsImageUploader;

jQuery(function() {
  if ($('.form_with_image_upload.directUpload').find("input:file").length > 0) {
    return window.alpha_oms.oms_image_uploader = new window.alpha_oms.oms_image_uploader_constructor();
  }
});

}).call(window);
